import { request, query } from '@/utils/request';
import { stringify } from 'qs';
import { getAppyDetailInterface, getClaimDetailInterface } from 'src/config/sceneEnum';

const urls = {
  list: '/zlb/api/expense/cashier/operateQuery', // 列表
  institution: '/api/zlbuser/institution/by/dataRule',
  apply: '/zlb/api/expense/apply-form/query',
  claim: '/zlb/api/expense/expense-form/getInfoOnCashier',
  getMobile: '/api/workbench/my/confirm_info/get', // 信息确认
  userData: '/api/user/getOperatorList',
  exportForm: '/zlb/api/expense/common/exportForm', // 导出申请单、报销单列表
  exportIncomeForm: '/zlb/budget/api/income/apply-form/export-query-form-list', // 导出收入列表
};

// 列表查询
export const reqUserData = (data) => {
  return request(urls.userData, { 
    method: 'POST', 
    data,
  });
};

// 列表查询
export const requestList = (params) => {
  return request(`${urls.list}?${stringify(params)}`);
};

// 单位列表查询
export const requestInstitution = (params) => {
  return request(urls.institution, { 
    params,
  });
};

// 申请单详情
export const reqApplyFormDetail = (params) => {
  return request(getAppyDetailInterface(), { 
    params,
  });
};

// 报销单详情
export const reqClaimFormDetail = (params) => {
  return request(getClaimDetailInterface(), { 
    params,
  });
};

export async function reqMobile (params) {
  return request(urls.getMobile, { params });
}

// 导出申请单、报销单Excel
export async function exportForm (data) {
  return request(urls.exportForm, { 
    method: 'POST',
    data,
    responseType: 'blob',
  });
}

// 导出收入Excel
export async function exportIncomeForm (data) {
  return request(urls.exportIncomeForm, { 
    method: 'POST',
    data,
    responseType: 'blob',
  });
}

// 报销单导出任务
export async function getExpenseExport (data) {
  return query('/zlb/api/expense/export/expense-export', { 
    method: 'POST',
    data,
  });
}

// 报销单导出获取fieldID
export async function getExportFileId (params) {
  return query(`/zlb/api/expense/export/query-export-result/${params.code}`);
}

// 重置单据
export async function cashierResume (data) {
  return request('/zlb/api/expense/workflow/cashier/resume', {
    method: 'POST',
    data,
  });
}

// 财务岗查询操作记录
export async function getUserOperateRecord (params) {
  return query('/zlb/api/expense/common/cashier/operate-record', { params });
}
